import axios from "axios";

const api = axios.create({
    baseURL: 'https://api.institutoselmacosso.com.br'
})

export default api